import { View } from 'backbone.marionette';
import template from './index.jst';
import Chart from 'chart.js';
import {
	MatchUpModel, User,
} from "../../../../models";
import Radio from "backbone.radio";
import './index.styl';
// import _ from 'lodash';
const matchUpChannel = Radio.channel('match_up');


export class MatchUpChart extends View {
	get template() {
		return template;
	}

	get className() {
		return 'match-up-chart';
	}

	ui() {
		return {
			chart: '.js-chart',
			title: '.js-chart-title',
			wrapper: '.js-chart-wrapper',
			icon: '.js-chevron'
		}
	}

	events() {
		return {
			'click @ui.title': 'toggleChart'
		}
	}

	initialize() {
		this.chart = null;
		this.model = new MatchUpModel();

		this.listenTo(matchUpChannel, 'reset:chart', this.resetChart)
	}

	resetChart() {
		if (this.chart) {
			this.chart.destroy();
			this.chart = null;
		}
	}

	toggleChart() {
		this.getUI('wrapper').slideToggle();
		this.getUI('icon').toggleClass('ion-chevron-down');
		this.getUI('icon').toggleClass('ion-chevron-up');
	}

	hideChart() {
		this.getUI('wrapper').slideUp();
		this.getUI('icon').removeClass('ion-chevron-down');
		this.getUI('icon').addClass('ion-chevron-up');
	}

	init({ selected_round, squads, matchup_fixture }) {

		if (!User.has_assistant_coach && selected_round.get('status') === 'scheduled') {
			this.hideChart();
		}

		const labels = this.model.getChartLabels({ selected_round, squads }),
			{ home, away } = matchup_fixture,
			args = { home, away, selected_round },
			{ home_points, away_points } = this.model.getTeamsByMatches(args)
		;

		const ctx = this.getUI('chart'),
			fill = false,
			home_color = '#05E58D',
			away_color = '#959595',
			borderWidth = 1,
			type = 'line',
			spanGaps = false,
			pointBorderWidth = 1,
			pointBackgroundColor = '#fff',
			pointRadius = 5
		;

		const common_options = {
				pointBorderWidth, fill, type, spanGaps, borderWidth, pointRadius
			},
			datasets = [
				{
					label: 'Actual',
					data: home_points.real_score_arr,
					backgroundColor: home_color,
					borderColor: home_color,
					pointBackgroundColor: home_color,
					...common_options
				},
				{
					label: 'Actual',
					data: away_points.real_score_arr,
					backgroundColor: away_color,
					borderColor: away_color,
					pointBackgroundColor: away_color,
					...common_options
				}
			]
		;

		if (User.has_assistant_coach) {
			datasets.push({
				label: 'Projected',
				data: home_points.proj_score_arr,
				borderDash: [2, 2],
				backgroundColor: '#fff',
				borderColor: home_color,
				pointBackgroundColor,
				...common_options
			},

			{
				label: 'Projected',
				data: away_points.proj_score_arr,
				borderDash: [2, 2],
				backgroundColor: '#fff',
				borderColor: away_color,
				pointBackgroundColor,
				...common_options
			})
		}

		this.chart = new Chart(ctx, {
			data: {
				labels,
				datasets
			},
			options: {
				responsive: true,
				scaleLabel: {
					fontFamily: 'RLFont, sans-serif'
				},
				scales: {
					yAxes: [{
						id: 'y-axes',
						gridLines: {
							drawBorder: false,
							drawTicks: false,
							display: false,
							zeroLineWidth: 0,
							zeroLineColor: "transparent"
						},
						ticks: {
							color: '#DDDDDD',
							fontSize: 8,
							beginAtZero: false,
							padding: 20
						}
					}],
					xAxes: [
						{
							id: 'x-axes',
							gridLines: {
								drawBorder: false,
								color: '#fff',
								lineWidth: 2,
								zeroLineWidth: 0,
								zeroLineColor: "transparent"
							},
							ticks: {
								fontSize: 10,
								beginAtZero: false,
								color: '#A3AAB2',
								fontStyle: 'bold'
							}
						}]
				},
				elements: {
					line: {
						tension: 0, // disables bezier curves
					}
				}
			}
		});

		this.chart.generateLegend();
	}
}

export default MatchUpChart;